<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->

              <b-col cols="3">
                <label for="select-empresa">Empresa</label>
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-garagem_sol">Filial</label> 
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false"                   
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                   <label for="select-status">Status</label> 
                <multiselect id="selecao-status-sol" v-model="value_status"  required  
                :options="statuss" 
                :multiple="true"         
                :taggable="true"  
                @close="loadSinistro()"  
                @tag="addTag"                           
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="true">                 
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="2"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid  </label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Registro ou Nº do carro"></b-form-input>              
              </b-col>   

              <!-- condicional para exibir o botão planilha-->
              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2"  v-b-modal.modal-SinistroLancamentos @click="loadEmpresaCad(),loadNovoNroSinistro()"> 
                   Novo Sinistro
                </b-button>                      
              </b-col>

          </b-row>
    </b-form>


      <b-row>

        <b-card-group class="ml-3 mt-3" deck>       

            

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="SINISTRO PENDENTES"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ itemsFiltered.filter( s => s.status === 'PENDENTE').length }}
                  </h2>
                </b-card-text>
              </b-card>

                            <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="SINISTRO CANCELADO"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ itemsFiltered.filter( s => s.status === 'CANCELADO').length }}
                  </h2>
                </b-card-text>
              </b-card>
            

            
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="SINISTRO EM ATENDIMENTO"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ itemsFiltered.filter( s => s.status === 'EM ATENDIMENTO').length }}
                </h2>
                
                
              </b-card-text>
            </b-card>
            

          
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="SINISTRO FINALIZADOS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ itemsFiltered.filter( s => s.status === 'FINALIZADO').length }}
                </h2>
                
              </b-card-text>
      </b-card>        
      
      
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="TOTAL SINISTRO"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.length}}
              </h2>
              
            </b-card-text>
          </b-card>
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="R$ TERCEIROS"
            header-bg-variant="green"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.map(v => v.valor_terceiros).reduce((acumulador, valorAtual) => {return acumulador + parseFloat(valorAtual);}, 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) }}
              </h2>
              
            </b-card-text>
          </b-card>
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="R$ EMPRESA"
            header-bg-variant="green"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.map(v => v.valor_empresa).reduce((acumulador, valorAtual) => {return acumulador + parseFloat(valorAtual);}, 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) }}
              </h2>
              
            </b-card-text>
          </b-card>
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="R$ TOTAL"
            header-bg-variant="green"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{(itemsFiltered.map(v => v.valor_total).reduce((acumulador, valorAtual) => {return acumulador + parseFloat(valorAtual);}, 0)).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) }}
              </h2>
              
            </b-card-text>
          </b-card>
        </b-card-group> 
      

      </b-row>


    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="saclancamentos"  small hover striped sticky-header="756px"  :items="itemsFiltered" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregarSinistro(data.item), loadEmpresaCad(), loadFiliaisCad(),loadStatus(), loadLinhas(), loadResponsabilidade(), loadIntegracao(), loadMonta(), loadVeiculo(), loadOperador() "    title="Editar Sinistro"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-SinistroLancamentos>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

    <!--  inicio modal gravação do sinistro  -->
    <!--  inicio modal gravação do sinistro  -->
    <!--  inicio modal gravação do sinistro  -->
          <!--  MODAL SOLICITÇÕES  -->
      <div>        
        <b-modal id="modal-SinistroLancamentos" centered hide-footer size="xl"  @close="reset()" :title="`Cadastro de sinistro Nº.: ${sinistro.id == null ? nroSinistro :sinistro.id }`"  no-close-on-esc no-close-on-backdrop>               
          <div>
                <b-row>
                  <b-col sm="5" class="mt-1">
                    <label for="input-parecer">Empresa</label>
                    <div>                    
                      <b-form-select   id="infoTipo"               
                        v-model="sinistro.empresa_id"  
                        :options="empresas"
                        class="mb-3"
                        text-field="nomeempresarial"  
                        @change="loadFiliaisCad()"                          
                      >                
                      </b-form-select>
                    </div>
                  </b-col>

                  <b-col sm="4" class="mt-1">
                    <label for="input-parecer">Filial</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.filial_id"  
                        :options="filiais"
                        class="mb-3"
                        text-field="filial" 
                        @change="loadLinhas()"                           
                      >                
                      </b-form-select>
                    </div>
                  </b-col>

                  

         

                <b-col cols="3">
                  <label for="input-live">Data sinistro</label>                 
                  <b-input-group-text >{{ sinistro.dt_cadastro !=  null ?  moment(sinistro.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
                </b-col> 


                </b-row> 

                <b-row>
                <b-col cols="2"  class="mt-1">
                  <label for="input-live">Carro</label>  
                  <b-form-input v-model="sinistro.prefixo" @keyup.enter="loadVeiculo()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 
              

                <b-col cols="2" class="mt-1">            
                  <label for="input-live">Placa</label>          
                    <b-input-group-text>{{  veiculos.map(at => at.placa).join(', ') }}</b-input-group-text>  
                </b-col>             

                <b-col cols="2" class="mt-1">
                    <label for="input-live">R.E</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.registro"  @keyup.enter="loadOperador()" placeholder="" class="mb-3"></b-form-input>
                </b-col>             

                <b-col cols="3" class="mt-1">
                    <label for="input-live">Função</label> 
                    <b-input-group-text>{{ motorista && motorista[0] ? motorista[0].funcao : '-' }}</b-input-group-text>
                </b-col>


                <b-col sm="2" class="mt-1">
                    <label for="input-parecer">Linha</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.linha_id"  
                        :options="linhas"
                        class="mb-3"
                        text-field="linha"                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col>                           

                  <b-col cols="1" class="mt-1">
                    <label for="input-live"> </label> 
                    <b-button  variant="warning" class="mr-2 mt-1"  v-b-modal.modal-SinistroFotos>Fotos</b-button>  
                  </b-col>
                </b-row>

                <!-- endereço-->
                <b-row>
                  <b-col cols="6" class="mt-1">
                    <label for="input-live">Enderreço</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.logradouro" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             

                  <b-col cols="2" class="mt-1">
                      <label for="input-live">Nro</label> 
                      <b-form-input  id="infoAssunto" v-model="sinistro.numero" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             

                  <b-col cols="4" class="mt-1">
                      <label for="input-live">Bairro</label> 
                      <b-form-input  id="infoAssunto" v-model="sinistro.bairro" placeholder="" class="mb-3"></b-form-input>
                  </b-col>                             
                </b-row>

                <b-row>
                  <b-col cols="3" class="mt-1">
                    <label for="input-live">Cidade</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.cidade" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             

                  <b-col cols="3" class="mt-1">
                      <label for="input-live">Estado</label> 
                      <b-form-input  id="infoAssunto" v-model="sinistro.uf" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             

                  <b-col cols="2" class="mt-1">
                      <label for="input-live">CEP</label> 
                      <b-form-input  id="infoAssunto" v-model="sinistro.cep" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             

                  <b-col cols="4" class="mt-1">
                      <label for="input-live">Ponto de referência</label> 
                      <b-form-input  id="infoAssunto" v-model="sinistro.ponto_referencia" placeholder="" class="mb-3"></b-form-input>
                  </b-col>             
                </b-row>

                <!-- envolvidos -->
                                <b-row>
                  <b-col cols="2">                                              
                      <b-form-checkbox
                        id="terceiros" 
                        class="mb-3 mt-5"
                        v-model="sinistro.terceiros"                                      
                        name="checkbox-1"
                        value="true"
                        unchecked-value="false"
                        checked="true"
                      >                  
                      Terceiros
                      </b-form-checkbox>                
                  </b-col>

                  
                  <b-col cols="1">                                              
                      <b-form-checkbox
                        id="vitimas" 
                        class="mb-3 mt-5"
                        v-model="sinistro.vitimas"                                      
                        name="checkbox-1"
                        value="true"
                        unchecked-value="false"
                        checked="true"
                      >                  
                      Vítimas
                      </b-form-checkbox>                
                  </b-col>

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Qtd Vítimas</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.vitimas_qtd" placeholder="" class="mb-3"></b-form-input>
                  </b-col>   
                  
                  <b-col cols="1">                                              
                      <b-form-checkbox
                        id="fatais" 
                        class="mb-3 mt-5"
                        v-model="sinistro.vitimas_fatais"                          
                        name="checkbox-1"
                        value="true"
                        unchecked-value="false"
                        checked="true"
                      >                  
                      Fatais
                      </b-form-checkbox>                
                  </b-col>

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Qtd Fatais</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.vitimas_fatais_qtd" placeholder="" class="mb-3"></b-form-input>
                  </b-col>   

                  <b-col sm="4" class="mt-1">
                    <label for="input-parecer">Integração ERP</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.status_integracao_erp"  
                        :options="integracoes"
                        class="mb-3"
                        text-field="integracao"                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col> 

                </b-row>

                <b-row>
                  <b-col cols="12">
                    <b-form-textarea                   
                      id="infoConteudo"
                      v-model="sinistro.observacoes"
                      size="sm"
                      rows="6"            
                      placeholder="Informações do sinistro"                      
                    ></b-form-textarea>
                  </b-col>
                </b-row>

                <!-- Cobrança  -->
                <b-row>

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">R$ terceiros</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.valor_terceiros" placeholder="" class="mb-3"></b-form-input>
                  </b-col> 

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Valor Empresa</label>
                    <b-form-input
                      id="infoAssunto"
                      v-model="sinistro.valor_empresa"                                            
                      placeholder=""
                      class="mb-3"
                    ></b-form-input>
                  </b-col>  

 <b-col cols="3" class="mt-1">
      <label for="input-live">R$ total</label> 
      <b-input-group-text class="mb-3"  >{{ (parseFloat(sinistro.valor_terceiros) + parseFloat(sinistro.valor_empresa) + 0.00).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) }}</b-input-group-text>
    </b-col>

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">R$ desconto</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.valor_desconto" placeholder="" class="mb-3"></b-form-input>
                  </b-col>   

                  <b-col cols="3" class="mt-1">
                    <label for="input-live">R$ a cobrar</label> 
                    <b-input-group-text class="mb-3"  >{{ (parseFloat(sinistro.valor_terceiros) + parseFloat(sinistro.valor_empresa) - parseFloat(sinistro.valor_desconto)  + 0.00).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) }}</b-input-group-text>                    
                  </b-col>                     
                  
                </b-row>

                <!-- Cobrança  -->
                <b-row>

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">Qtd parcelas</label> 
                    <b-form-input  id="infoAssunto" v-model="sinistro.parcelas_qtd" placeholder="" class="mb-3"></b-form-input>
                  </b-col>   

                  <b-col cols="2" class="mt-1">
                    <label for="input-live">R$ da parcela</label> 
                                        <b-input-group-text class="mb-3"  >{{ parseInt(sinistro.parcelas_qtd) > 0  ?  ( ( (parseFloat(sinistro.valor_terceiros) + parseFloat(sinistro.valor_empresa) - parseFloat(sinistro.valor_desconto) ) / parseInt(sinistro.parcelas_qtd) )  ).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) : 'R$ 0,00'  }}</b-input-group-text>  
                    
                  </b-col>   

                  <b-col sm="3" class="mt-1">
                    <label for="input-parecer">Monta</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.monta_id"  
                        :options="montas"
                        class="mb-3"
                        text-field="monta"                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col> 
                  
                  <b-col sm="2" class="mt-1">
                    <label for="input-parecer">Responsabilidade</label> 
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.responsabilidade_id"  
                        :options="responsabilidades"
                        class="mb-3"
                        text-field="responsabilidade"                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col> 

                  <b-col sm="3" class="mt-1">
                    <label for="input-parecer">Status</label>
                    <div>                    
                      <b-form-select   id="infoFormato"               
                        v-model="sinistro.status_id"  
                        :options="statuss"
                        class="mb-3"
                        text-field="status"                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col> 
                </b-row>

                <b-row>
                  <!-- inserir o arquivo -->
                  <b-col cols="12" class="mt-1">
                    <b-form-file v-model="file"  @input="uploadPhoto()" placeholder="Selecione o arquivo" ref="file-input" class="mb-2"></b-form-file>
                  </b-col>   
                </b-row>

              <b-row>
                <b-col cols="12">
                <p class="mt-2">Arquivo selecionado: <b>{{ file ? file.name : '' }}</b></p></b-col>
                <p v-if="this.user.id_grupo == 18" class="ml-3">{{ sinistro.sinistro_url}}</p>
              </b-row>

              <!-- </form> -->
              <b-button class="mt-3" variant="success" block @click="postSinistro(), loadSinistro()">Gravar Sinistro</b-button>          
          </div>          
        </b-modal>
      </div>
    <!--  fim -  modal gravação do sinistro  -->
    <!--  fim -  modal gravação do sinistro  -->
    <!--  fim -  modal gravação do sinistro  -->

    
    <!--  inicio modal fotos do sinistro  -->
    <!--  inicio modal fotos do sinistro  -->
    <!--  inicio modal fotos do sinistro  -->
          <!--  MODAL fotos  -->

         <div>
  <b-modal id="modal-SinistroFotos" hide-footer size="lg" :title="`Cadastro de sinistro Nº.: ${sinistro.id == null ? '' :sinistro.id }`" no-close-on-backdrop>
    <div class="d-flex justify-content-center " style="height: 80vh;">
      <b-carousel
        id="carouselFoto"
        class="carouselFoto"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          v-for="(photo, index) in sinistro.fotos"
          :key="index"
          :img-src="photo"
        ></b-carousel-slide>
      </b-carousel>
    </div>
  </b-modal>
</div>



    <!--  fim -  modal fotos do sinistro  -->
    <!--  fim -  modal fotos do sinistro  -->
    <!--  fim -  modal fotos do sinistro  -->



    

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import * as XLSX from 'xlsx'


export default {    
    name: 'sinistro',    

    
    computed : { ... mapState (['user'],),

    


/*
    computed: {
      formattedValorTotal: {
        get() {
          const formattedValue = this.sinistro.valor_total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
          console.log('Valor formatado:', formattedValue);
          return formattedValue;
        },
        // ...
      },
    },
*/



    
        itemsFiltered(){
        let valores = [];       
        valores = this.sinistros.filter((item) =>{ 
          const prefixo = item.prefixo || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const id = item.id || '';
          const operador = item.registro || '';
          
           return (
             prefixo.indexOf(this.search) >-1 ||
             id.indexOf(this.search) >-1 ||
             operador.indexOf(this.search) >-1            
          );
        });
           return valores

        },

        



   
    } ,

    

    data: function() {        
      
        return {

          
          
          slide: 0,
          sliding: null,

          empresas:[],   // [] lista       
          empresa:{}, 
          filiais: [],   // [] lista            
          filial:{}, 
          sinistros:[],
          sinistro:{},
          nroSinistro:null,  
          formattedValorTotal: '', // Variável para armazenar o valor formatado

          linhas:[],
          responsabilidades:[],
          integracoes:[],
          montas:[],
          statuss: [],   // [] lista  
          motorista:[]          ,
          
          mode: 'save',
            carregando: false,
            atualizando: false,   
            value_empresa:[],// [this.empresas],            
            value_filial:[],            
            value_status:[],     
            //value_filial:[],// [] lista     
            
            status:{},

            permissoes:[],
            permissao:{},
                                     
   
            pedidoferias:[],    // implantado 08/07/2023
            sacT:{},// [] lista  
            sinistrostratativa:[],// [] lista
            search:'',
       
            value_id_area:'',  
            veiculos:[],                        
            operador:[],               
            operadores:[],               
            

            fields: [
                { key: 'empresa_id', label: 'Empresa', sortable: true },                 
                { key: 'filial_id', label: 'Filial', sortable: true },                 
                { key: 'id', label: 'Nº Sinistro', sortable: true },     
                { key: 'prefixo', label: 'Carro', sortable: true },                     
                { key: 'linha', label: 'Linha', sortable: true },     
                { key: 'dt_cadastro', label: 'Data Sinistro', sortable: true, formatter: (value, key, sinistros) => {
                    return moment(sinistros.dt_cadastro).format('DD/MM/YYYY - HH:mm ').replace('Data inválida','-') ; }  },                
                { key: 'registro', label: 'Responsável', sortable: true },  
                { key: 'funcao', label: 'Função', sortable: true },                  
                { key: 'dt_alteracao', label: 'Data Alteração', sortable: true, formatter: (value, key, sinistros) => {
                    return moment(sinistros.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },                   
                { key: 'valor_empresa', label: 'R$ Empresa', sortable: true  }, 
                { key: 'valor_terceiros', label: 'R$ Terceiros', sortable: true  }, 
                { key: 'status', label: 'Status', sortable: true  }, 
                { key: 'observacoes', label: 'Observações', sortable: true }, 
                { key: 'logradouro', label: 'Endereço', sortable: true },                                            
                { key: 'bairro', label: 'Bairro', sortable: true }, 
                { key: 'actions', label: 'Atualizar' },                
            ],
        }        
    },


    components: {
        Multiselect
    },

    
    methods: {



      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },

      

      loadEmpresaCad() {
            let params = {    

                /*
                "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`, 
                              "id_empresa": `${this.user.id_empresa}`,
                              */
                                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.user.id_filial_erp,  // Verifica se há filiais e junta os ids como string   
                              
                "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                 
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params})
          .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
          .catch(showError)
      },

      loadFiliaisCad() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": `${this.user.id_empresa}`,
                "psg":  `${this.user.psg}`,                                       
            };

          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params})
            .then(res => {
              this.filiais = res.data.map(fil => {                      
                return { ... fil, value: fil.id_filial_erp, filial: fil.filial }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },

      loadLinhas() {
          let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,             
          };
          const url = `${baseApiUrl}/planejamento/linha/cad`
          axios.get(url,{params})
            .then(res => {
              this.linhas = res.data.map(lin => {                      
                return { ... lin, value: lin.id_linha, linha: lin.linha }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },

        /* data criação 30/08/2023 */

        loadResponsabilidade() {
                    let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,            
          };
          const url = `${baseApiUrl}/sinistro/responsabilidade`
          axios.get(url,{params})
            .then(res => {
              this.responsabilidades = res.data.map(resp => {                      
                return { ... resp, value: resp.id, responsabilidade: resp.responsabilidade }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },

        loadIntegracao() {
                              let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,              
          };
          const url = `${baseApiUrl}/sinistro/integracao`
          axios.get(url,{params})
            .then(res => {
              this.integracoes = res.data.map(inte => {                      
                return { ... inte, value: inte.id, integracao: inte.integracao }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },

        loadMonta() {
                              let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,       
          };
          const url = `${baseApiUrl}/sinistro/monta`
          axios.get(url,{params})
            .then(res => {
              this.montas = res.data.map(mon => {                      
                return { ... mon, value: mon.id, monta: mon.monta }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },

        loadSinistro() {
            let params = {    
             //   "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                            
                "id_empresa": `${this.user.id_empresa}`,                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                            
                "status_id": `${this.value_status.map(s => s.id)}`,      
                "psg":  `${this.user.psg}`,                                             
            };
          const url = `${baseApiUrl}/sinistro/analitico`
          axios.get(url,{params})
          .then(res => { this.sinistros = res.data })
          .catch(showError)
        },

            loadNovoNroSinistro() {
               let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,             
          };

          const url = `${baseApiUrl}/sinistro/novonrosinistro`
          axios.get(url,{params}).then(res => {
            this.nroSinistro = res.data.rows[0].nextval
          })
    },



                loadPreventivasHistorico() {  
                   let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,           
          };                      
            const url = `${baseApiUrl}/preventiva/historico/${this.carro}`                               
            axios.get(url,{params}).then(res => {                                
                this.carregando = false;
                this.preventivashistoricos = res.data                
            })            
        },





      
      loadEmpresas() {
                   let params = {    
           //   "id_empresa": `${this.user.id_empresa}`,
           //   "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
           //     "psg":  `${this.user.psg}`,           
            "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.filiais.map(f => f.id_filial_erp)  ?  `${this.filiais.map(f => f.id_filial_erp)}` : this.user.id_filial_erp,  // Verifica se há filiais e junta os ids como str
                   "psg":  `${this.user.psg}`,     
          };      
          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params}).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
      },  

      loadFiliais() {
                   let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,           
          };      
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params}).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      }, 

      loadStatus() {
                   let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "id_filial": `${this.filiais.map(f => f.id_filial_erp)}`,
                "psg":  `${this.user.psg}`,           
          };      
          const url = `${baseApiUrl}/sinistro/status`
          axios.get(url,{params}).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id, status: sta.status }
            })
          })
      },

        




        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.pedidoferias

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'pedido_de_ferias.xlsx');
      },


      loadCarregarSinistro(sinistro){
            this.sinistro = { ...sinistro }
      },        

      postSinistro() {                        
        let corpo = { 
                "id": this.nroSinistro ? this.nroSinistro : `${this.sinistro.id}`,
                "funcionario_lancamento_id": `${this.user.id_funcionario}`,
                "empresa_id": `${this.sinistro.empresa_id}`,
                "filial_id": `${this.sinistro.filial_id}`,
                "funcionario_id":this.motorista ? this.motorista[0].id_funcionario : `${this.sinistro.funcionario_id}`,          // responsavel identificado na avaria         motorista[0].funcao
                "linha_id": `${this.sinistro.linha_id}`,                
                "logradouro": `${this.sinistro.logradouro}`,                
                "numero": `${this.sinistro.numero}`,                
                "bairro": `${this.sinistro.bairro}`,                
                "cep": `${this.sinistro.cep}`,                
                "cidade": `${this.sinistro.cidade}`,                
                "uf": `${this.sinistro.uf}`,                
                "ponto_referencia": `${this.sinistro.ponto_referencia}`,                
                "observacoes": `${this.sinistro.observacoes}`,                
                "status_id": `${this.sinistro.status_id}`,                                
                "terceiros": `${this.sinistro.terceiros}`,                
                "vitimas": `${this.sinistro.vitimas}`,                
                "vitimas_qtd": `${this.sinistro.vitimas_qtd}`,                
                "vitimas_fatais": `${this.sinistro.vitimas_fatais}`,                
                "vitimas_fatais_qtd": `${this.sinistro.vitimas_fatais_qtd}`,                
                "veiculo_id": this.veiculos.length != 0  ? `${this.veiculos.map(v => v.id_veiculo)}`:  `${this.sinistro.veiculo_id}`,                
                "responsabilidade_id": `${this.sinistro.responsabilidade_id}`,                
                "status_integracao_erp": this.sinistro.status_integracao_erp ? `${this.sinistro.status_integracao_erp}` : 1,                
                "valor_terceiros": this.sinistro.valor_terceiros ? `${parseFloat(this.sinistro.valor_terceiros.replace(/[^\d,.]/g, '').replace(',', '.'))}` : 0,                
                "valor_empresa": this.sinistro.valor_empresa?  `${parseFloat(this.sinistro.valor_empresa.replace(/[^\d,.]/g, '').replace(',', '.'))}` : 0,                                
                "valor_desconto":this.sinistro.valor_desconto?  `${parseFloat(this.sinistro.valor_desconto.replace(/[^\d,.]/g, '').replace(',', '.'))}` : 0,                
                "valor_cobrado": ( parseFloat( parseFloat(this.sinistro.valor_terceiros) + parseFloat(this.sinistro.valor_empresa) - parseFloat(this.sinistro.valor_desconto))    ) > 0 ? `${ parseFloat( parseFloat(this.sinistro.valor_terceiros) + parseFloat(this.sinistro.valor_empresa) - parseFloat(this.sinistro.valor_desconto))}` : 0,                                               //parsefloat
                "valor_total":  `${parseFloat(parseFloat(this.sinistro.valor_terceiros) + parseFloat(this.sinistro.valor_empresa))}` ,                                                                                            //parsefloat
                "parcelas_qtd": `${this.sinistro.parcelas_qtd}`,                
                "parcelas_valor": `${ parseFloat( (parseFloat(this.sinistro.valor_terceiros) + parseFloat(this.sinistro.valor_empresa) - parseFloat(this.sinistro.valor_desconto) ) / parseInt(this.sinistro.parcelas_qtd))}`,   //parsefloat                
                "monta_id": `${this.sinistro.monta_id}` ,      
                "carro_id": this.veiculos.length != 0  ? `${this.veiculos.map(v => v.id_veiculo)}`: this.corretiva.carro_id,
                "dt_cadastro": `${this.sinistro.dt_cadastro}`,
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros     

                
        };

        const url = `${baseApiUrl}/sinistro`   

            axios.post(url,corpo).then(() => {
              this.loadSinistro
              this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores                    
                })
                .catch(showError)
      },

      reset() {                        
            this.sinistro = {}
            this.loadSinistro()
            this.nroSinistro =null
      },

      postNotificacao() {                        
          let corpo = {                
                "id_funcionario": `${this.sinistro.id_funcionario_solicitante}`,
                "message": 'Existe uma nova tratativa para sua solicitação nº '+`${this.sinistro.id_solicitacao}`,                
                "dt_notificacao": now().toString ,
                "type": 1,

                        
        };

        const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`   

            axios.post(url,corpo).then(() => {
                    //this.$toasted.global.defaultSuccess()
                   // this.loadsinistrosTratativas()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

      limparFiltro(){
        this.search= ""
      },



        loadVeiculo() {
          let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "prefixo": `${this.sinistro.prefixo}`    ,
               "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                  
          };
          const url = `${baseApiUrl}/frota/veiculo`
          axios.get(url,{params})                      
          .then(res => { this.veiculos = res.data })                      
          .catch(showError)
        },




      async loadOperador() { 
            let params = {                             
            "id_empresa": `${this.sinistro.empresa_id}`,                                             
            "registro": `${this.sinistro.registro}`,
             "psg": this.user.psg // Adiciona o 'psg' nos parâmetros           
            
            };             
          const url = `${baseApiUrl}/folha/funcionario/busca`
          axios.get(url,{params})
              .then(res => { this.motorista = res.data })             
      }, 
  
    },  


  mounted() {    
        this.loadSinistro()
        this.loadEmpresas()
        this.loadEmpresaCad()
        this.loadIntegracao()
        this.loadMonta()
        this.loadResponsabilidade()
        this.loadStatus()

        
  },
    

}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.carouselFoto {
  max-width: 65%;
  height: auto;
  /* Defina a altura máxima que você deseja para as imagens */
  max-height: 100px;
}



</style>